import { render, staticRenderFns } from "./Testeminie.vue?vue&type=template&id=6c02e2a1&lang=pug&"
import script from "./Testeminie.vue?vue&type=script&lang=ts&"
export * from "./Testeminie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports